<template>
  <div class="mode-card-container">
      <div class="mode-nav">
    <h3 class="mode-card-header reserve-header">RESERVE</h3>
      </div>
    <div class="mode-card-content">
      <div class="mode-card-description" v-if="!isModeActive">
        <p>{{ $t('general.cards.reserve_about') }}</p>
        <ul>
          <li class="plus-item">{{ $t('general.cards.menu') }}</li>
          <li>{{ $t('general.cards.deposit') }}</li>
          <li>{{ $t('general.cards.info_reserve') }}</li>
        </ul>
        <p></p>
        <ul>
          <li class="plus-item">{{ $t('general.cards.application') }}</li>
          <li>{{ $t('general.cards.pro_pt1') }}</li>
          <li>{{ $t('general.cards.pro_pt2') }}</li>
          <li>{{ $t('general.cards.pro_pt3') }}</li>
          <li>{{ $t('general.cards.pro_pt4') }}</li>
        </ul>
        <p>{{ $t('general.cards.link') }}</p>
      </div>
      <div class="mode-card-status" v-if="isModeActive">
        <ul>
          <li v-for="(enabled,setting) in readySettings" :key="setting" :class="enabled ? 'active' : ''">
              {{ enabled ? '+' : '-'}}
              {{ $t(`mode_settings.${setting}`) }}
              <span class="mode-card-setting-hint" v-if="!enabled">
                {{ $t(`mode_settings_hints.${setting}`) }}
              </span>
          </li>
        </ul>
      </div>
      <div class="mode-card-controls" v-if="!isModeActive">
        <button class="mode-control-button connect-button" @click="isModeActive = true">
          {{ $t('general.cards.connect') }} | {{ subscription.price }}$ / {{ $t('general.cards.month') }}
        </button>
      </div>
      <div class="mode-card-controls" v-if="isModeActive">
        <button class="mode-control-button settings-button" @click="navigateToSettings">
            {{ $t('settings.title') }}
        </button>
        <button
          class="mode-control-button disconnect-button iqos-group-item"
          @click="isModeActive = false"
        >{{ $t('general.cards.disconnect') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
      navigateToSettings() {
          this.$router.push('/reserve');
      }
  },    
  computed: {
    readySettings() {
        const original = this.$store.getters.readyReserve;

        let filtered = Object.assign({}, original);

        delete filtered.total;
        delete filtered.subtotal;

        return filtered;
    },
    isModeActive: {
      get() {
        if (!this.cafe.modes) return false;
        return this.cafe.modes.reserve;
      },
      set(value) {
        if (!value) this.$emit('disconnected');
        this.$store.commit("toggleCafeMode", {
          mode: "reserve",
          value
        });
        this.$store.dispatch("saveCafe");

        this.$store.dispatch('auditlog/write', {
          type: value ? 'mode_enable' : 'mode_disable', 
          payload: {
            mode: 'reserve'
          }
        });
      }
    },
    cafe() {
        return this.$store.state.cafe;
    },
    subscription() {
      return this.$store.state.subscriptions.reserve;
    }
  }
};
</script>

<style scoped>
.reserve-header {
  color: #AECCC6;
}
</style>